import { get } from '../../utils/object-helpers';
import storeEvent from '../../utils/store-event';

const CLS = {
    removePrevNextBtns: 'remove-prev-next-buttons'
};
const SEL = {
    viewport: '.str-quickview-carousel__list',
    item: '.str-quickview-carousel__list li',
    nextBtn: '.str-quickview-carousel__next',
    prevBtn: '.str-quickview-carousel__prev'
};

export default class {
    onInput(input) {
        const removePrevNextBtns = get(input, 'items', []).length <= 6;
        this.numOfItemsInViewport = removePrevNextBtns ? 6 : 5;
        return {
            ...input,
            removePrevNextBtns,
            removePrevNextBtnsClass: removePrevNextBtns ? CLS.removePrevNextBtns : ''
        };
    }
    onMount() {
        this.viewport = this.query(SEL.viewport);
        // Listen for quickview event to scroll to item.
        storeEvent.quickviewCarouselIndex.listen(data => {
            this.scrollToIndex(parseInt(data.index));
        });
    }
    onUpdate() {
        this.nextBtn = this.query(SEL.nextBtn);
        this.prevBtn = this.query(SEL.prevBtn);
        if (this.nextBtn && this.prevBtn) {
            this.nextBtn.addEventListener('click', this.scrollNext.bind(this));
            this.prevBtn.addEventListener('click', this.scrollPrev.bind(this));
        }
        this.onEndScroll();
        this.disablePrevNextButtons();
        this.disableItemsOutOfView();
    }
    scrollNext() {
        this.scrollOnButtonClick();
    }
    scrollPrev() {
        this.scrollOnButtonClick(true);
    }
    scrollOnButtonClick(isPrev) {
        const item = this.query(SEL.item);
        if (item) {
            let distance = this.numOfItemsInViewport * item.offsetWidth;
            distance = isPrev ? -distance : distance;
            this.viewport.scrollBy({ left: distance });
        }
    }
    query(sel) {
        if (this.el) {
            return this.el.querySelector(sel);
        }
    }
    queryAll(sel) {
        if (this.el) {
            return this.el.querySelectorAll(sel);
        }
    }
    disablePrevNextButtons() {
        if (this.nextBtn && this.prevBtn) {
            const items = this.queryAll(SEL.item);
            if (items) {
                const maxScrollLeft = this.getMaxScrollLeft();
                if (items.length <= this.numOfItemsInViewport) {
                    this.nextBtn.disabled = true;
                    this.prevBtn.disabled = true;
                    return;
                }
                this.nextBtn.disabled = false;
                this.prevBtn.disabled = false;

                if (this.viewport.scrollLeft >= maxScrollLeft) {
                    this.nextBtn.disabled = true;
                } else if (this.viewport.scrollLeft === 0) {
                    this.prevBtn.disabled = true;
                }
            }
        }
    }
    // Prevent keyboard nav to items outside of viewport by adding 'disabled' attribute.
    disableItemsOutOfView() {
        const items = this.queryAll(SEL.item);
        // roundingFix is needed to help with a rounding error.
        // When the browser view is zoomed in or out there seems to be a pixel rounding error in Chrome:
        // https://bugs.chromium.org/p/chromium/issues/detail?id=608142
        const roundingFix = 1;
        if (items) {
            const viewportWidth = this.numOfItemsInViewport * items[0].offsetWidth;
            let width = 0;
            items.forEach(item => {
                const button = item.querySelector('button');
                if (button) { // Spacer item has no button
                    width += item.offsetWidth;
                    const isBtnLeftOfViewport = width <= this.viewport.scrollLeft + roundingFix;
                    const isBtnRightOfViewport = width > viewportWidth + this.viewport.scrollLeft + roundingFix;

                    if (isBtnLeftOfViewport || isBtnRightOfViewport) {
                        button.disabled = true;
                    } else {
                        button.disabled = false;
                    }
                }
            });
        }
    }
    getMaxScrollLeft() {
        const fudge = 1;
        const items = this.queryAll(SEL.item);
        if (items) {
            const width = Array.from(items).reduce((sum, item) => sum + item.offsetWidth, 0);
            return width - (this.numOfItemsInViewport * items[0].offsetWidth) - fudge;
        }
    }
    onEndScroll() {
        let timeoutId;
        this.viewport.addEventListener('scroll', () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                this.disablePrevNextButtons();
                this.disableItemsOutOfView();
            }, 100);
        });
    }
    scrollToIndex(index) {
        const items = this.queryAll(SEL.item);
        if (items) {
            if (index >= items.length) {
                return;
            }
            const dist = (index * items[0].offsetWidth) - this.viewport.scrollLeft;
            this.viewport.scrollBy({ left: dist });
        }
    }
}
